export var CallStatsStatus;
(function (CallStatsStatus) {
    CallStatsStatus[CallStatsStatus["WAITING"] = 1] = "WAITING";
    CallStatsStatus[CallStatsStatus["IN_PROGRESS"] = 2] = "IN_PROGRESS";
    CallStatsStatus[CallStatsStatus["COMPLETED"] = 3] = "COMPLETED";
    CallStatsStatus[CallStatsStatus["NO_ANSWER"] = 4] = "NO_ANSWER";
    CallStatsStatus[CallStatsStatus["VOICEMAIL"] = 5] = "VOICEMAIL";
})(CallStatsStatus || (CallStatsStatus = {}));
//# sourceMappingURL=call-stats-status.js.map